"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var AddPlus = function AddPlus(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/add_plus-add-plus" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-add-plus" + unique,
    xlinkHref: "#path-1-add-plus" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-add-plus" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13,11 L20.5,11 C20.7761424,11 21,11.2238576 21,11.5 L21,12.5 C21,12.7761424 20.7761424,13 20.5,13 L13,13 L13,20.5 C13,20.7761424 12.7761424,21 12.5,21 L11.5,21 C11.2238576,21 11,20.7761424 11,20.5 L11,13 L3.5,13 C3.22385763,13 3,12.7761424 3,12.5 L3,11.5 C3,11.2238576 3.22385763,11 3.5,11 L11,11 L11,3.5 C11,3.22385763 11.2238576,3 11.5,3 L12.5,3 C12.7761424,3 13,3.22385763 13,3.5 L13,11 Z",
    fill: "inherit",
    id: "path-1-add-plus" + unique
  }))));
};

AddPlus.propTypes = propTypes;
var _default = AddPlus;
exports["default"] = _default;